import React from "react";
import { Link } from "react-router-dom";
import Logo from "./renn/Logo";
import { FOOTER } from "../mock";

const FooterLink = ({ l }) =>
  l.href.startsWith("/") ? (
    <Link to={l.href} className="text-sm text-[#8290A8] hover:text-[#13D99A] transition-colors">
      {l.label}
    </Link>
  ) : (
    <a href={l.href} className="text-sm text-[#8290A8] hover:text-[#13D99A] transition-colors">
      {l.label}
    </a>
  );

const Footer = () => {
  return (
    <footer className="relative border-t border-[#29354A] bg-[#050A12]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="flex flex-col lg:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <Logo className="text-2xl" />
            <p className="mt-4 text-[#8290A8] text-sm">{FOOTER.about}</p>
          </div>
          <nav className="flex flex-wrap gap-x-10 gap-y-3 lg:max-w-md">
            {FOOTER.links.map((l) => (
              <FooterLink key={l.label} l={l} />
            ))}
          </nav>
        </div>

        <div className="mt-12 pt-8 border-t border-[#29354A] space-y-4">
          <p className="text-xs text-[#8290A8]/80 leading-relaxed max-w-4xl">{FOOTER.disclaimer}</p>
          <p className="text-xs text-[#8290A8]">{FOOTER.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
